import { AnnotationPlugin } from '@st/document-viewer-kit'
import { StampAnnotation } from '@st/sdk'
import { SignOffsToolState } from '~/st-doc-viewer/annotations'
import { SignOffAnnotationElement } from './element'
import { completeSignOffAnnotation } from './model'

export function signOffsPlugin(): AnnotationPlugin<StampAnnotation, SignOffsToolState> {
  return {
    name: 'sign_offs',
    initialToolState: { name: 'sign_offs', settings: {} },
    completeAnnotation: completeSignOffAnnotation,
    Element: SignOffAnnotationElement,
    handlesAnnotation: (annotation) =>
      annotation.type === 'stamp' && (annotation as StampAnnotation).stampType === 'sign_off'
  }
}
